import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";

// Same endpoints and polling as the desktop NotificationBell, for the
// mobile header bell and the Alerts tab.
export default function useNotifications() {
  const [items, setItems] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [loaded, setLoaded] = useState(false);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/lead-assignment/notifications", { params: { limit: 15 } });
      setItems(data.items || []);
      setUnreadCount(data.unread_count || 0);
    } catch { /* not every role can read this / not configured yet — fine, just stay quiet */ }
    setLoaded(true);
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, [load]);

  const markRead = async (n) => {
    if (n.read) return;
    try { await api.post(`/lead-assignment/notifications/${n.id}/read`); } catch { /* ignore */ }
    setItems((prev) => prev.map((x) => (x.id === n.id ? { ...x, read: true } : x)));
    setUnreadCount((c) => Math.max(0, c - 1));
  };

  const markAllRead = async () => {
    try { await api.post("/lead-assignment/notifications/read-all"); } catch { /* ignore */ }
    setItems((prev) => prev.map((x) => ({ ...x, read: true })));
    setUnreadCount(0);
  };

  return { items, unreadCount, loaded, load, markRead, markAllRead };
}
